import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { borderRadiusValues, nbsp } from 'shared/lib/utils/uiConstants';
import { GridRowContext } from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import { makeTransition, sizeToString } from 'shared/lib/utils/utils';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';
import IconFile from 'shared/icons/iconFile';
import { formatBackToFrontDate } from 'shared/lib/utils/globalUtils';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

const clamp = 1;

export default function MobileTableNameCell({
  name,
  updatedAt,
  onClick,
}: {
  name: string;
  updatedAt: string;
  onClick?: () => void;
}) {
  const theme = useTheme();
  const { sp, icons } = defaultSpacingPresets;
  const { isHover } = useContext(GridRowContext);

  const color = isHover
    ? theme.palette.primary.main
    : theme.palette.text.primary;

  return (
    <CellContainer onClick={onClick} sx={{ pl: '0 !important' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: sp.s50,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            width: icons['48x48'].w,
            height: icons['48x48'].h,
            minWidth: icons['48x48'].w,
            minHeight: icons['48x48'].h,
            borderRadius: borderRadiusValues.XSmall,
          }}
        >
          <IconFile sizeKey="48x48"></IconFile>
        </Paper>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s20,
            width: 1,
          }}
        >
          <LimitedTypography
            variant="f18b"
            clamp={clamp}
            sx={{
              color,
              transition: makeTransition(['color']),
            }}
          >
            {name}
          </LimitedTypography>

          <Typography sx={{ display: 'inline-flex' }}>
            <Typography
              sx={{ fontSize: '14px !important' }}
              color="text.secondary"
            >
              Таблица
            </Typography>
            <Typography
              sx={{ fontSize: '14px !important' }}
              color="text.secondary"
            >
              {nbsp} / {nbsp}
            </Typography>
            <Typography
              sx={{ fontSize: '14px !important' }}
              color="text.secondary"
            >{`Изменено: ${formatBackToFrontDate(updatedAt)}`}</Typography>
          </Typography>
        </Box>
      </Box>
    </CellContainer>
  );
}
